import { CLIENT_METHODS, RESOURCES, useApiMutation } from '@/data/api'

export const useResendCode = (): ReturnType<typeof useApiMutation> =>
  useApiMutation(RESOURCES.RESEND_CODE, CLIENT_METHODS.POST)
